module.exports = __webpack_public_path__ + "static/media/proposition.6db72932.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/spr/form/proposition.pdf
// module id = 864
// module chunks = 40